import { useState } from 'react';
import { useSelector } from 'react-redux';
import TableTitle from '../../Shared/Table/widgets/TableTitle';
import TablePageContainer from '../../Shared/Table/widgets/TablePageContainer';
import ProgramList from './ProgramList';

const Programs = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const [filterStyle, setFilterStyle] = useState(false);
  const [totalCount, setTotalCount] = useState(' ');

  return (
    <>
      <TablePageContainer>
        <ProgramList
          setFilterStyle={setFilterStyle}
          setTotalCount={setTotalCount}
          tableTitle={<TableTitle
            titleText={titles.programs}
            count={totalCount}
            countFiltered={filterStyle}
          />}
        />
      </TablePageContainer>
    </>
  );
};

export default Programs;

